import React from 'react';
import axios from "axios";
import { useNavigate } from 'react-router-dom';

import { Container, Grid, useMantineTheme, Box, Group, Flex } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { notifications } from '@mantine/notifications';
import { v4 as uuidv4 } from 'uuid';
import { IconReload } from '@tabler/icons-react';

import { useLoginContext } from "../../../context/loginContext";

import { BE_API_ONE, utils, subMenuProject, tabProject } from "../../../utils/globalVariables";
import { regexNoStriped, getPropInSubLevelRole, safetyDecodeJWT } from "../../../utils/globalFunctions";

import AmountOfData from "../../../components/general/AmountOfData";
import ActionIconComponent from "../../../components/general/ActionIconComponent";

import NoData from "../../../components/general/NoData";
import WrapperUtils from "../../../layout/WrapperUtils";

import ReminderProjectCard from "./ReminderProjectCard";
// import PengecekanFilter from "./PengecekanFilter";
import ReminderProjectSelected from "./ReminderProjectSelected";

const ReminderProjectIndex = ({
    stateMenu,
    stateSubMenu,
    stateTab,
}) => {

    const mountedRef = React.useRef(true);

    const navigate = useNavigate();
    const theme = useMantineTheme();
    const matchesMinMD = useMediaQuery(`(min-width: ${theme.breakpoints.md})`);
    const { loginContext, handleSetLoginContext } = useLoginContext();

    const sortList = {
        tanggalNota: {
            slug: 'tanggal_nota',
            caption: 'Tanggal Masuk',
            type: utils.sortType.date.slug
        },
        tanggalSelesai: {
            slug: 'tanggal_selesai',
            caption: 'Tanggal Selesai',
            type: utils.sortType.date.slug
        },
        tanggalAmbil: {
            slug: 'tanggal_ambil',
            caption: 'Tanggal Ambil',
            type: utils.sortType.date.slug
        },
        customerName: {
            slug: 'customer_name',
            caption: 'Customer',
            type: utils.sortType.string.slug
        },
        barangCategoryName: {
            slug: 'barang_category_name',
            caption: 'Kategori Barang',
            type: utils.sortType.string.slug
        },
        barangNama: {
            slug: 'barang_nama',
            caption: 'Barang',
            type: utils.sortType.string.slug
        },
        barangKeluhan: {
            slug: 'barang_keluhan',
            caption: 'Keluhan',
            type: utils.sortType.string.slug
        },
        teknisi: {
            slug: 'ms_u_penerima_rekomendasi.user_name',
            caption: 'Teknisi',
            type: utils.sortType.string.slug
        },
    }

    const [data, setData] = React.useState({
        data: [],
        dataCount: 0,
        dataFlag: 'idle',
        dataLoading: false,
        dataRefresh: new Date(),
        dataOffset: 0,
        dataSortSelected: sortList.tanggalNota,

        selectedData: null,
        selectedDrawer: false,
        selectedTriggerUpdate: new Date(),
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    const fnSort = (stateSortSelected) => {
        setData(d => ({
            ...d,
            dataLoading: true,
            dataSortSelected: {
                ...d.dataSortSelected,
                slug: d.dataSortSelected.slug[0] === '-' ? stateSortSelected.slug : '-' + stateSortSelected.slug,
                caption: stateSortSelected.caption,
                type: stateSortSelected.type
            }
        }));
    };

    const AmountOfDataComponent = () => {
        return (
            <AmountOfData
                stateDataLimit={utils.dataLimit}
                stateDataOffset={data.dataOffset}
                stateAmountDataAll={data.dataCount}
                stateDataFlag={data.dataFlag}
                stateSuffix=''

                fnFirstData={(stateNewOffset) => setData(d => ({
                    ...d,
                    dataLoading: true,
                    dataRefresh: new Date(),
                    dataOffset: stateNewOffset
                }))}

                fnLastData={(stateNewOffset) => setData(d => ({
                    ...d,
                    dataLoading: true,
                    dataRefresh: new Date(),
                    dataOffset: stateNewOffset
                }))}

                fnPreviousData={(stateNewOffset) => setData(d => ({
                    ...d,
                    dataLoading: true,
                    dataRefresh: new Date(),
                    dataOffset: stateNewOffset
                }))}

                fnNextData={(stateNewOffset) => setData(d => ({
                    ...d,
                    dataLoading: true,
                    dataRefresh: new Date(),
                    dataOffset: stateNewOffset
                }))}
            />
        )
    }

    React.useEffect(() => {
        setData(d => ({ ...d, dataLoading: true }));

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContext.syswebapp);
        formDT.append('data_limit', utils.dataLimit);
        formDT.append('data_offset', data.dataOffset);
        formDT.append('order_by', regexNoStriped(data.dataSortSelected.slug));
        formDT.append('order_type', data.dataSortSelected.slug[0] === '-' ? 'asc' : 'desc');

        formDT.append('flag_all', utils.flagAll);
        formDT.append('project_is_cancel', '0');

        formDT.append('maintenance_flag', utils.projectType.maintenance.value);
        formDT.append('step_sudah_diambil_flag', utils.projectProcess.sudah_diambil.value);

        axios({
            method: 'post',
            url: BE_API_ONE + '/get_reminder_maintenance',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, dataLoading: false }));

            if (response.data.flag_status === 'isset') {
                setData(d => ({
                    ...d,
                    data: response.data.data,
                    dataCount: response.data.data_count,
                    dataFlag: response.data.data.length > 0 ? true : false,
                }));
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({
                ...d,
                dataLoading: false,
            }));

            notifications.show({
                id: uuidv4(),
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: true,
            })
        })
    }, [handleSetLoginContext, loginContext, data.dataRefresh, data.dataSortSelected.slug, data.dataOffset])

    const handleSelectedProject = (stateProjectId, stateCustomerId, stateProjectStep) => {
        let tab = '';

        if (stateProjectStep === utils.projectProcess.nota.value) {
            tab = tabProject.nota;
        } else if (stateProjectStep === utils.projectProcess.antrian.value) {
            tab = tabProject.antrian;
        } else if (stateProjectStep === utils.projectProcess.pengerjaan.value) {
            tab = tabProject.pengerjaan;
        } else if (stateProjectStep === utils.projectProcess.qc.value) {
            tab = tabProject.qc;
        } else if (stateProjectStep === utils.projectProcess.selesai.value) {
            tab = tabProject.selesai;
        } else if (stateProjectStep === utils.projectProcess.sudah_diambil.value) {
            tab = tabProject.sudahDiambil;
        }

        navigate(`/${getPropInSubLevelRole(safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappsl'), 'slugLink', '')}/${stateMenu}/${subMenuProject}/${tab}/${stateProjectStep === utils.projectProcess.nota.value ? stateCustomerId : stateProjectId}`, { replace: true });
    }

    return (
        <React.Fragment>
            <WrapperUtils
                stateDataLoading={data.dataLoading}
            >
                <Group spacing='xs' noWrap>
                    <ActionIconComponent
                        stateVariant='light'
                        stateRadius='xl'
                        stateTitle='Reload Data'
                        stateSize='lg'
                        fnOnClick={() => setData(d => ({ ...d, dataLoading: true, dataRefresh: new Date() }))}

                        StateIcon={IconReload}
                        stateIconSize='1.125rem'
                        stateIconStrokeWidth={1.25}
                        stateIconStyle={{
                            color: theme.colorScheme === 'light' ? '#000' : theme.colors.gray[0]
                        }}
                    />
                </Group>

                {matchesMinMD &&
                    <Flex
                        sx={{ flex: 1 }}
                        justify="flex-end"
                        align="center"
                        direction="row"
                        wrap="nowrap"
                    >
                        <AmountOfDataComponent />
                    </Flex>
                }
            </WrapperUtils>

            <Container fluid>
                <Grid my={0}>
                    {data.data.length <= 0 && data.dataFlag !== 'idle' &&
                        <Grid.Col span={12}>
                            <NoData />
                        </Grid.Col>
                    }

                    {data.data.length > 0 &&
                        <Grid.Col
                            span={12}
                            py={0}
                        >
                            <Box mt='md'>
                                <ReminderProjectCard
                                    stateData={data.data}
                                    stateSortList={sortList}
                                    stateSortSelected={data.dataSortSelected}
                                    fnSort={(val) => {
                                        fnSort(val);
                                    }}

                                    fnGoToStep={(arrayVal) => {
                                        handleSelectedProject(arrayVal.project_id, arrayVal.customer_id, arrayVal.project_process);

                                        // setData(d => ({ ...d, dataRefresh: new Date(), dataLoading: true }));
                                        // ! apakah ini perlu ? perlu update index sewaktu pilih nota ?
                                    }}

                                    fnSelected={(arrayVal) => {
                                        setData(d => ({
                                            ...d,
                                            selectedData: arrayVal,
                                            selectedTriggerUpdate: new Date(),
                                            selectedDrawer: true
                                        }))
                                    }}
                                />
                            </Box>
                        </Grid.Col>
                    }

                    {data.data.length > 0 &&
                        <Grid.Col span={12} className='amountOfDataBottom'>
                            <Group mt='xs' mb='md' position='apart'>
                                <Box>&nbsp;</Box>

                                <AmountOfDataComponent />
                            </Group>
                        </Grid.Col>
                    }
                </Grid>
            </Container>

            <ReminderProjectSelected
                stateShow={data.selectedDrawer}
                fnShow={(val) => setData(d => ({ ...d, selectedDrawer: val }))}
                stateData={{
                    data: data.selectedData,
                }}

                stateTriggerUpdate={data.selectedTriggerUpdate}
                fnUpdateIndex={() => {
                    setData(d => ({ ...d, dataLoading: true, dataRefresh: new Date() }))
                }}
            />
        </React.Fragment>
    )
}

export default ReminderProjectIndex;